import classnames from "classnames";
import React, { ReactNode } from "react";
import {
  LandingPageItem,
  SanityLandingPageCustomBlock
} from "../../model/landing-page";
import BlockColorHero from "../BlockColorHero/BlockColorHero";
import { Wrapper } from "../Grid";
import { HomePageIntro } from "../HomePageIntro/HomePageIntro";
import LandingPageCardsContentBlock from "../LandingPageCardsContentBlock/LandingPageCardsContentBlock";
import LandingPageCarousel from "../LandingPageCarousel/LandingPageCarousel";
import LandingPageCarouselRow from "../LandingPageCarouselRow/LandingPageCarouselRow";
import LandingPageImageContentBlock from "../LandingPageImageContentBlock/LandingPageImageContentBlock";
import ContentCard from "./ContentCard";
import styles from "./LandingPageContent.module.scss";
import TitleBoxHero from "./TitleBoxHero";
import FeaturedStatisticsList from "../FeaturedStatisticsList/FeaturedStatisticsList";

interface LandingPageContentProps {
  className?: string;
  content: LandingPageItem[];
  title: string;
  renderCustom?: (item: SanityLandingPageCustomBlock) => ReactNode;
}

const LandingPageContent = ({
  className,
  content,
  title,
  renderCustom = () => null
}: LandingPageContentProps) => {
  const contentComponents = content.map((item, index) => {
    switch (item._type) {
      case "landingPageTitleBoxHero":
        return (
          <TitleBoxHero
            className={
              item.layout ? styles[item.layout.replace(/-/g, "")] : undefined
            }
            social={index === 0}
            value={item}
            title={title}
            key={item._key}
          />
        );
      case "landingPageBlockColorHero": {
        return <BlockColorHero key={item._key} value={item} />;
      }
      case "landingPageContentCard":
        return (
          <ContentCard
            value={item}
            key={item._key}
            customEmbeds={{
              featuredStatisticsList: (props: any) => (
                <FeaturedStatisticsList {...props} layout="prominent" />
              )
            }}
          />
        );
      case "landingPageHomePageIntro":
        return <HomePageIntro value={item} key={item._key} />;
      case "landingPageCarousel":
        return <LandingPageCarousel value={item} key={item._key} />;
      case "landingPageCarouselRow":
        return <LandingPageCarouselRow value={item} key={item._key} />;
      case "landingPageImageContentBlock":
        return <LandingPageImageContentBlock value={item} key={item._key} />;
      case "landingPageCardsContentBlock":
        return <LandingPageCardsContentBlock value={item} key={item._key} />;
      case "landingPageCustomBlock":
        return renderCustom(item);
      default:
        throw new Error(`Unknown landing page item: ${(item as any)._type}`);
    }
  });
  return (
    <Wrapper className={classnames(styles.root, className)}>
      {contentComponents}
    </Wrapper>
  );
};

export default LandingPageContent;
